import React, { PropsWithChildren } from "react";
import { Box, BoxProps } from "@mui/material";

const Section: React.FC<PropsWithChildren<BoxProps>> = ({ children, ...rest }) => {
  return (
    <Box component={"section"} {...rest}>
      {children}
    </Box>
  );
};

export default Section;
